import { ROUTES } from "./routes";

export const BRAND = {
  name: "CARLINK",
  tagline: "Your Vehicle. Always Reachable.",
  positioning: "One sticker. No app. No phone number exposed.",
  legalName: "carlinkin",
};

// Demo QR encodes plain text only — it never resolves to a live vehicle.
export const DEMO_SERIAL = "CL-8X92K7";
export const DEMO_QR_VALUE = "CARLINK DEMO STICKER CL-8X92K7 - not linked to any vehicle";

export const NAV_LINKS = [
  { label: "Home", to: ROUTES.HOME, testId: "nav-link-home" },
  { label: "How It Works", to: ROUTES.HOW_IT_WORKS, testId: "nav-link-how-it-works" },
  { label: "Pricing", to: ROUTES.PRICING, testId: "nav-link-pricing" },
  { label: "FAQ", to: ROUTES.FAQ, testId: "nav-link-faq" },
  { label: "Contact", to: ROUTES.CONTACT, testId: "nav-link-contact" },
];

export const PRODUCT_MESSAGES = ["One sticker.", "No app.", "No phone number exposed.", "Your vehicle stays reachable."];

export const STEPS = [
  { n: "01", title: "Register", body: "Register your vehicle with CARLINK." },
  { n: "02", title: "Get your CARLINK ID", body: "CARLINK creates a unique digital identity and QR code for your vehicle." },
  { n: "03", title: "Stay reachable", body: "Place your CARLINK sticker on your vehicle. Someone can scan it whenever they need to contact you." },
];

export const FEATURES = [
  { id: "parking-alerts", icon: "Car", title: "Parking Alerts", body: "Someone can notify you when your vehicle is blocking them." },
  { id: "private-communication", icon: "ShieldCheck", title: "Private Communication", body: "People can contact you without seeing your personal phone number." },
  { id: "no-app-required", icon: "Smartphone", title: "No App Required", body: "Scanning works through a normal mobile browser." },
  { id: "emergency", icon: "Siren", title: "Emergency", body: "Important vehicle-related alerts can reach you quickly." },
  { id: "digital-identity", icon: "Fingerprint", title: "Digital Vehicle Identity", body: "Every vehicle gets a unique CARLINK identity." },
  { id: "smart-qr-sticker", icon: "QrCode", title: "Smart QR Sticker", body: "The physical sticker connects the real vehicle to its digital identity." },
];

export const SCAN_REASONS = [
  { id: "blocking", icon: "Car", label: "Vehicle is blocking me" },
  { id: "lights-on", icon: "Lightbulb", label: "Lights are ON" },
  { id: "door-window", icon: "DoorOpen", label: "Door/window is open" },
  { id: "emergency", icon: "Siren", label: "Emergency" },
  { id: "contact-owner", icon: "MessageSquare", label: "Contact Owner" },
  { id: "other", icon: "CircleHelp", label: "Other" },
];

// Placeholder pricing — edit `price` values here when final pricing is confirmed.
export const PRICING_PLANS = [
  {
    id: "basic",
    name: "CARLINK Basic",
    price: "₹XXX",
    period: "per vehicle",
    summary: "Everything a single vehicle needs to stay reachable.",
    features: ["Vehicle digital identity", "Dynamic QR", "Basic alerts", "Owner portal"],
  },
  {
    id: "plus",
    name: "CARLINK Plus",
    price: "₹XXX",
    period: "per vehicle",
    summary: "Richer alerts and communication for owners who want more.",
    features: ["Everything in Basic", "Advanced alerts", "Communication features", "Advanced vehicle features"],
    highlight: true,
  },
  {
    id: "multi-vehicle",
    name: "Multi-Vehicle",
    price: "Custom",
    period: "for 2+ vehicles",
    summary: "For customers with multiple vehicles.",
    features: ["One owner account for every vehicle", "A unique CARLINK ID per vehicle", "Plan options per vehicle"],
  },
];

export const FAQS = [
  { q: "What is CARLINK?", a: "CARLINK is a digital identity and communication platform for vehicles. Each registered vehicle gets a unique CARLINK ID linked to a physical QR sticker, so people can reach the owner when the vehicle needs attention." },
  { q: "Do I need an app?", a: "No. Owners manage CARLINK through a web portal, and the person scanning the sticker uses their normal phone camera and browser. Nobody needs to install an app or create an account to scan." },
  { q: "Does CARLINK expose my phone number?", a: "No. The QR code contains only your CARLINK ID — never your name or phone number. CARLINK sits between the person scanning and you, so your personal number is not shown to them." },
  { q: "Where should I place the sticker?", a: "The sticker is designed for the front or rear windshield, in a spot that is easy to see and scan from outside the vehicle without blocking the driver's view." },
  { q: "Can I register multiple vehicles?", a: "Yes. CARLINK is designed for owners with more than one vehicle — each vehicle gets its own CARLINK ID and sticker under one owner account." },
  { q: "Can I download my QR code?", a: "Yes. When the Owner Portal launches, you will be able to download your QR as a high-resolution PNG, a printable PDF and a print-ready sticker — all pointing to the same CARLINK ID." },
  { q: "What happens if I change my phone number?", a: "Your sticker keeps working. The QR points to your CARLINK ID, not your number, so you only update your contact details in your account." },
  { q: "Can someone contact me if my vehicle is blocking them?", a: "That is exactly what CARLINK is built for. The person scans the sticker and chooses a reason such as \"Vehicle is blocking me\". Alert delivery is being rolled out in stages and is not live yet." },
  { q: "Can I transfer a vehicle to another owner?", a: "CARLINK links each QR to a vehicle and an owner separately, so vehicle transfers are supported by design. The transfer process will be available in a future release — contact us if you need help." },
  { q: "What happens if my sticker is damaged?", a: "Because the QR is dynamic, a replacement sticker can be linked to the same vehicle and the damaged one can be retired so it no longer works. Contact us to arrange a replacement." },
];
